import {
  enumPrinterStatus,
  enumPrinterType,
} from '@rematter/frontend-lib-api-client';

import type { PrinterDetailRecord } from '../types/sidecar';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const printerDetailQueryAtom = createQueryAtomFactory(
  'settings.printerDetail',
  (params: { ids: string[] }) => ({
    printers: {
      __args: {
        filter: {
          ids: params.ids,
        },
        pagination: {
          limit: 1,
          offset: 0,
        },
      },
      entries: {
        id: true,
        sidecarId: true,
        uniqueId: true,
        driverType: true,
        name: true,
        manufacturer: true,
        model: true,
        firmwareVersion: true,
        printerType: true,
        pageSize: true,
        rollWidth: true,
        status: true,
        online: true,
        lastSeenAt: true,
        sidecar: {
          id: true,
          name: true,
          peerId: true,
          multiaddrs: true,
          status: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data): PrinterDetailRecord | null => {
      const entry = data?.printers?.entries?.[0];
      if (!entry) {
        return null;
      }

      return {
        id: entry.id,
        sidecarId: entry.sidecarId,
        uniqueId: entry.uniqueId,
        driverType: entry.driverType,
        name: entry.name,
        manufacturer: entry.manufacturer ?? null,
        model: entry.model ?? null,
        firmwareVersion: entry.firmwareVersion ?? null,
        printerType: entry.printerType ?? enumPrinterType.Standard,
        pageSize: entry.pageSize ?? null,
        rollWidth: entry.rollWidth ?? null,
        status: entry.status ?? enumPrinterStatus.Discovered,
        online: entry.online ?? false,
        lastSeenAt: entry.lastSeenAt
          ? parseZonedDateTime(entry.lastSeenAt)
          : null,
        sidecar: entry.sidecar
          ? {
              id: entry.sidecar.id,
              name: entry.sidecar.name,
            }
          : null,
        sidecarDetail: entry.sidecar
          ? {
              id: entry.sidecar.id,
              name: entry.sidecar.name,
              peerId: entry.sidecar.peerId ?? null,
              multiaddrs: (entry.sidecar.multiaddrs as string[]) ?? [],
              status: entry.sidecar.status,
            }
          : null,
        timestamps: {
          createdAt: parseZonedDateTime(entry.timestamps.createdAt),
          updatedAt: parseZonedDateTime(entry.timestamps.updatedAt),
        },
      };
    },
  },
);
